import React from "react";
import Types from "prop-types";
import { Helmet } from "react-helmet";
import { withTranslation, Trans } from "react-i18next";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { ReCaptcha } from "../../Guard";
import AuroraCheckbox from "../inputs/aurora-checkbox/AuroraCheckbox";
import PhoneNumber from "../../common/PhoneNumber";
import styles from "./styles";

function OneClickPhoneLoginForm(props) {
  const {
    t,
    classes,
    error,
    rememberMe,
    submitting,
    merchant,
    onSubmit,
    onPhoneChange,
    onCheckboxChange,
  } = props;

  return (
    <form onSubmit={onSubmit}>
      <Helmet>
        <title>Login | Careem</title>
      </Helmet>
      <div className={classes.title}>
        <Typography component="h1" className={classes.formTitle}>
          {t("one_click_checkout:title")}
        </Typography>
        <Typography component="h3" className={classes.formSubtitle}>
          <Trans i18nKey="one_click_checkout:subtitle">
            Sign in to Careem to continue checkout
            {merchant && (
              <span>
                on
                <span>{{ merchantName: merchant }}</span>
              </span>
            )}
          </Trans>
        </Typography>
      </div>
      <div className="material-form-field">
        <PhoneNumber onPhoneChange={onPhoneChange} error={error} />
      </div>
      <input
        className="btn-careem-aurora"
        type="submit"
        value={submitting ? t("common:please_wait") : t("common:continue")}
        name="verify-recover-btn"
        disabled={submitting}
      />
      <div className={classes.checkboxContainer}>
        <FormControlLabel
          checked={rememberMe}
          onChange={onCheckboxChange}
          classes={{ label: classes.checkboxLabel }}
          control={<AuroraCheckbox disableRipple />}
          label={t("one_click_checkout:stay_signed_in")}
        />
      </div>
      <ReCaptcha />
    </form>
  );
}

OneClickPhoneLoginForm.propTypes = {
  classes: Types.object.isRequired,
  t: Types.func,
  rememberMe: Types.bool.isRequired,
  onCheckboxChange: Types.func.isRequired,
  onPhoneChange: Types.func.isRequired,
  onSubmit: Types.func.isRequired,
  error: Types.string,
  merchant: Types.string,
  submitting: Types.bool.isRequired,
};

export default withTranslation()(withStyles(styles)(OneClickPhoneLoginForm));
